import api from '../_api'
import {
    FETCH_CLOUDFRONT_REQUEST,
    FETCH_CLOUDFRONT_SUCCESS,
    FETCH_CLOUDFRONT_FAILED
} from './mutation-type'

const getCloudFront = async ({ commit, state, getters, rootGetters }, { projectIdx, month }) => {
    commit(FETCH_CLOUDFRONT_REQUEST)
    try {
        const { status, data } = await api.fetchCloudFront({ projectIdx, month }, rootGetters.requiredService)
        commit(FETCH_CLOUDFRONT_SUCCESS, { status, data: data.data })
    } catch (error) {
        commit(FETCH_CLOUDFRONT_FAILED, error)
    }
}

export default {
    getCloudFront
}
